import * as React from 'react';

var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var SvgCrownOutline = function SvgCrownOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3C12.2532 3 12.4892 3.12769 12.6278 3.33956L16.4877 9.24306L21.8721 6.10217C22.1277 5.9531 22.447 5.96818 22.6873 6.14066C22.9277 6.31315 23.0442 6.61081 22.9848 6.90062L20.75 17.8022L20.7499 17.8023C20.4876 19.0816 19.3619 20 18.0559 20H5.94412C4.63818 20 3.5124 19.0815 3.25015 17.8022L1.01531 6.90062C0.955898 6.61081 1.0724 6.31315 1.31275 6.14067C1.5531 5.96818 1.87239 5.9531 2.12793 6.10217L7.51232 9.24306L11.3723 3.33956C11.5108 3.12769 11.7469 3 12 3ZM12 5.12049L8.37776 10.6604C8.15921 10.9947 7.71708 11.0991 7.37213 10.8978L2.82179 8.24347L4.71959 17.501L3.98932 17.6507L4.71959 17.501C4.8388 18.0825 5.35055 18.5 5.94412 18.5H18.0559C18.6496 18.5 19.1612 18.0826 19.2805 17.5009L21.1783 8.24347L16.6279 10.8978C16.283 11.0991 15.8408 10.9947 15.6223 10.6604L12 5.12049Z"
  })));
};

export { SvgCrownOutline as ReactComponent };
//# sourceMappingURL=crown-outline.svg.js.map
